export default "/images/card-login-ic.svg?326d08fe02b5cce9050815722585ba87";